module.exports = __webpack_public_path__ + "static/media/bg-xanh-2_2020-11-26.09057a95.png";